import { GET_COLORS } from '../types';

const initialState = {
  colors: [],
};

export default function Color(state = initialState, action) {
  switch (action.type) {
    case GET_COLORS:
      return {
        ...state,
        colors: action.payload,
      };
    default:
      return state;
  }
}
